export const ConsumerEditPhoneNumberSectionFormUat = {
  errorMessage: 'workflow.consumerPhoneValidation.editPhoneNumber.errorMessage',
  field: 'workflow.consumerPhoneValidation.editPhoneNumber.field',
  submitButton: 'workflow.consumerPhoneValidation.editPhoneNumber.submitButton',
  cancelButton: 'workflow.consumerPhoneValidation.editPhoneNumber.cancelButton',
}
